var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3239 27.023H3.35249V3.28835C3.35249 2.35582 2.60214 1.59998 1.67612 1.59998C0.75035 1.59998 0 2.35582 0 3.28835V27.8969C0 29.2793 1.11252 30.4 2.48494 30.4H30.3239C31.2497 30.4 32 29.6441 32 28.7116C32 27.7788 31.2494 27.023 30.3239 27.023Z",
    fill: "#6A829A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.442 4.41996C30.1818 4.14084 29.814 3.98756 29.4337 4.00079L24.6704 4.15923C23.9406 4.18343 23.3682 4.7975 23.3922 5.53097C23.4163 6.26443 24.027 6.83978 24.7581 6.81493L26.0458 6.77201L16.6297 16.2306L13.9848 14.1057C13.4814 13.7014 12.7613 13.7201 12.2798 14.1505L5.64378 20.0786C5.09771 20.5662 5.04889 21.4061 5.53425 21.9544C5.79539 22.2496 6.15837 22.4 6.52295 22.4C6.83549 22.4 7.14964 22.2893 7.40147 22.0644L13.2039 16.8811L15.9018 19.0486C16.428 19.4713 17.1864 19.429 17.663 18.9505L27.8164 8.75169L27.6985 9.96467C27.6275 10.6952 28.1594 11.3448 28.8866 11.4161C28.8992 11.4174 28.912 11.4184 28.9245 11.4193C29.636 11.4684 30.2618 10.9401 30.3315 10.2225L30.7937 5.45772C30.8306 5.07695 30.7025 4.69876 30.442 4.41996Z",
    fill: "#9AD880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.96df68e0daff527322e044fa41c215cc.svg";
export { ForwardRef as ReactComponent };